import { render, staticRenderFns } from "./UcTemplateSelector.yaml?vue&type=template&id=72ae4042&component"
import script from "./UcTemplateSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcTemplateSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports